export default __webpack_public_path__ + "static/media/legal.0cd912d9.svg";